import React, { useEffect, useState, useRef, Component } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from '../../core/contexts/ThemeContext';
import { useWindows } from '../../core/contexts/WindowContext';
import { useAppRegistry } from '../../core/contexts/AppRegistry';
import { Window } from './Window';
import { Dock } from './Dock';
import { MenuBar } from './MenuBar';
import { CommandPalette } from './CommandPalette';
import { AppInitializer } from './AppInitializer';
import { BootSequence } from './BootSequence';
function EmptyDesktop() {
  const {
    theme
  } = useTheme();
  const isLightTheme = theme === 'light';
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95,
    filter: 'blur(10px)'
  }} animate={{
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    scale: 0.95,
    filter: 'blur(10px)'
  }} transition={{
    duration: 1.2,
    ease: 'easeOut'
  }} className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none z-0" data-id="element-190" data-mp="25ejzz8ql6xc1">
      <div className="flex flex-col items-center gap-6" data-id="element-191" data-mp="3ufl2tx838tzl">
        <h1 className={`text-7xl md:text-9xl font-medium tracking-tighter m-0 ${isLightTheme ? 'text-black/[0.08]' : 'text-white/[0.08]'}`} data-id="element-192" data-mp="3ucyuvwhaccgu">
          {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </h1>
        <div className="flex flex-col items-center gap-2" data-id="element-193" data-mp="3gh4n5gs8zt5b">
          <h2 className={`text-xl md:text-2xl font-medium tracking-tight m-0 ${isLightTheme ? 'text-black/40' : 'text-white/40'}`} data-id="element-194" data-mp="3bgz0kf0u4wu3">
            MvlCreative
          </h2>
          <span className={`font-mono text-[10px] tracking-widest uppercase ${isLightTheme ? 'text-black/20' : 'text-white/20'}`} data-id="element-195" data-mp="19plydxq9531q">
            MvlCreative OS v2.0
          </span>
        </div>
      </div>
    </motion.div>;
}
export function Desktop() {
  const {
    theme,
    t
  } = useTheme();
  const {
    windows,
    openWindow
  } = useWindows();
  const {
    getAppById
  } = useAppRegistry();
  const isLightTheme = theme === 'light';
  const [isBooting, setIsBooting] = useState(true);
  const hasOpenedHome = useRef(false);
  // Auto-open Home window ONCE after boot completes
  useEffect(() => {
    if (!isBooting && !hasOpenedHome.current) {
      hasOpenedHome.current = true;
      const timer = setTimeout(() => {
        openWindow('home', t('home.title'));
      }, 2500); // Wacht 2.5 seconden zodat de gebruiker de lege desktop/klok ziet
      return () => clearTimeout(timer);
    }
  }, [isBooting]);
  return <div className={`w-full min-h-screen relative overflow-hidden ${isLightTheme ? 'wallpaper-light' : 'wallpaper-dark'}`} data-id="element-196" data-mp="r28yt1vhy2pe">
      <AppInitializer data-id="element-197" data-mp="ojdx2pkojbxu" />

      <AnimatePresence data-id="element-198" data-mp="oiw0fru3uvpe">
        {isBooting && <BootSequence onComplete={() => setIsBooting(false)} data-id="element-199" data-mp="ohuid3eo98y6" />}
      </AnimatePresence>

      {!isBooting && <>
          <MenuBar data-id="element-200" data-mp="jmnffxt888ab" />
          <CommandPalette data-id="element-201" data-mp="xju0y05c4l38" />

          {/* Empty Desktop State */}
          <AnimatePresence data-id="element-202" data-mp="xhzlh1cu1l6j">
            {windows.every(w => w.isMinimized) && <EmptyDesktop data-id="element-203" data-mp="smajysh95u7l" />}
          </AnimatePresence>

          {/* Windows Layer */}
          <div className="absolute inset-0 pt-10 pb-20 pointer-events-none z-10" data-id="element-204" data-mp="4wg8ae8o6box">
            <AnimatePresence data-id="element-205" data-mp="umaqetrtnsz">
              {windows.map(window => {
            const app = getAppById(window.appId);
            if (!app) return null;
            const AppComponent = app.component;
            return <Window key={window.id} window={window} data-id="element-206" data-mp="9t6pj4w7ndbx">
                    <AppComponent projectId={window.projectId} data-id="element-207" data-mp="3i9jabxn9reoj" />
                  </Window>;
          })}
            </AnimatePresence>
          </div>

          <Dock data-id="element-208" data-mp="3qxyr5f3zuvw4" />
        </>}
    </div>;
}